export {
    SignatureStatus,
    DOCUMENTS_SLICE,
    FILES_IS_EMPTY_MESSAGE,
    FILE_UNIQUE_FIELD_NAME,
    NO_FILES_MESSAGE,
    NO_HEADER_ORGANIZATION,
    NOT_FILLED_FIELDS_MESSAGE,
    SIGN_UNIQUE_FIELD_NAME,
    TOTAL_ENTITY,
} from './model/constants';

export type {
    IDocumentUploadFile,
    IDocumentUploadFileResponse,
    IDocumentsState,
    IDocumentUploadedSignature,
    IDocumentUploadSignature,
    IDocumentTypeResponse,
    IDocumentSaveInfoFile,
    IEntityFileUploadState,
    IFileUploadType,
    IExecuteMonitoringData,
    IDocumentUploadScan,
    IEntitySignatureUploadState,
    IDocumentsUploadMonitoring,
    IMonitoringResult,
    IProgramSetStage,
    IMonitoringResultLog,
    IProgramSetProgram,
    IMonitoringProgram,
    IDocumentsUploadMonitoringResult,
    IDocumentTemplatesTypeResponse,
    IFileAttachInfoResponse,
    TFileRowStateDataType,
} from './model/types';

export {
    EDocumentsSigningMethod,
    EFileSizeFormat,
    EMonitoringStatusCode,
    EFileUploadStatus,
    EStageStatus,
    EXsdValidationStatusCodes,
} from './model/types';

export {
    selectDocumentTypes,
    selectDocumentTypeOnUpload,
    selectDocumentBranchNames,
    selectDocumentFileUpload,
    selectDocumentFileUploadByEntityName,
    selectDocumentSignatureUploadByEntityName,
    selectDocumentsSigningMethod,
    selectDocumentProperties,
    selectDocumentExtensions,
    selectDocumentsUploadMonitoring,
    selectDocumentsPagination,
    selectDocumentsForUploadAttach,
    selectDocumentSignatureUpload,
    selectDocumentList,
} from './model/selectors';

export {
    fetchFileAttachInfo,
    fetchFileUploadProperties,
    fetchTemplateTypesForFile,
    uploadAttachedToDocument,
    downloadDocumentScan,
    deleteDocumentScan,
    fetchDocumentScansById,
    deleteDocumentScansByDocumentId,
    downloadScansArchiveByDocumentId,
    fetchDocumentAttachInfo,
    fetchDocumentInfo,
    getFinalStatus,
    fetchFileDuplicatesInfo,
} from './api/api';

export {
    documentsUploadingSliceReducer,
    setFileList,
    resetFileList,
    setDocumentsPagination,
    setSignList,
    clearAllSignsInfo,
    clearAllFilesInfo,
    clearDocumentsForSign,
    resetRowStateDataForEditableTable,
} from './model/slice';

export {
    loadBranchNames,
    loadFileRowStateDataInEditableTable,
    loadAcceptableExtensions,
    loadDocumentTypesOnUpload,
    loadDocumentTypes,
    loadDocumentsSigningMethod,
    loadDocumentsForUploadAttach,
    loadDocumentsForSign,
    loadDefaultSignInfo,
    uploadSignatureFiles,
    loadBranchesLinkingFlag,
    uploadDocumentFiles,
} from './api/thunks';

export {
    filterFilesByExtensions,
    removeExtraPartFromEntityName,
    generateSignatureInfoFromDocumentInfo,
    generateDefaultFileInfo,
} from './lib/utils';
